var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_7753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8C11.448 8 11 7.552 11 7V6C11 5.448 11.448 5 12 5H13C13.552 5 14 5.448 14 6V7C14 7.552 13.552 8 13 8H12ZM17 8H18C18.552 8 19 7.552 19 7V6C19 5.448 18.552 5 18 5H17C16.448 5 16 5.448 16 6V7C16 7.552 16.448 8 17 8ZM16 12C16 12.552 16.448 13 17 13H18C18.552 13 19 12.552 19 12V11C19 10.448 18.552 10 18 10H17C16.448 10 16 10.448 16 11V12ZM18.5 0H11.5C8.468 0 6 2.468 6 5.5C6 6.328 6.672 7 7.5 7C8.328 7 9 6.328 9 5.5C9 4.121 10.121 3 11.5 3H18.5C19.879 3 21 4.121 21 5.5V18.5C21 19.879 19.879 21 18.5 21H17.5C16.672 21 16 21.672 16 22.5C16 23.328 16.672 24 17.5 24H18.5C21.532 24 24 21.532 24 18.5V5.5C24 2.468 21.532 0 18.5 0ZM15 15.94V19.5C15 21.981 12.981 24 10.5 24H4.5C2.019 24 0 21.981 0 19.5V15.94C0 14.415 0.689 13.001 1.891 12.059L4.463 10.046C6.25 8.648 8.749 8.647 10.538 10.046L13.108 12.057C14.31 12.999 15 14.414 15 15.94ZM12 15.94C12 15.343 11.73 14.79 11.26 14.42L8.69 12.409C8.339 12.135 7.919 11.998 7.501 11.998C7.083 11.998 6.662 12.135 6.313 12.408L3.741 14.421C3.271 14.789 3.002 15.343 3.002 15.94V19.5C3.002 20.327 3.675 21 4.502 21H10.502C11.329 21 12.002 20.327 12.002 19.5V15.94H12ZM8 16H7C6.448 16 6 16.448 6 17V18C6 18.552 6.448 19 7 19H8C8.552 19 9 18.552 9 18V17C9 16.448 8.552 16 8 16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_7753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.2182e57965a8ab2ba42ecdb91abf175b.svg";
export { ForwardRef as ReactComponent };